import React, { createContext, useContext, useEffect, useReducer } from 'react';

import { GET } from '../helper/api';
import { clear, getToken, getUser, set, setToken, setUser } from '../helper/auth';
export const Types = {
  LOGOUT: 'LOGOUT',
  LOGIN: 'LOGIN',
  UPDATE: 'UPDATE'
}

const initialState = {
  user: getUser() ? JSON.parse(getUser()) : null,
  token: getToken()
}


const UserStateContext = createContext({
  state: initialState,
  dispatch: () => null
});

function userReducer(state, action) {
  switch (action.type) {
    case Types.LOGIN: {
      const { token, user } = action.item
      setUser(JSON.stringify(user));
      setToken(token)
      return {
        token, user
      }
    }
    case Types.UPDATE: {
      const { user } = action.item
      setUser(JSON.stringify(user));
      return {
        ...state,
        user
      }
    }

    case Types.LOGOUT: {
      clear();
      return {
        user: null,
        token: null
      }
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

export const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(userReducer, initialState);

  useEffect(() => {
    const { token } = state;
    if (token) {
      GET("/user/info", {}, true).then((resp) => {
        const { role } = resp.data;
        set("ROLE", role);
        setUser(JSON.stringify(resp.data));
        dispatch({
          type: Types.UPDATE,
          item: {
            user: resp.data,
          },
        });
      });
    }
  }, []);

  return (
    <UserStateContext.Provider value={{ state, dispatch }}>
      {children}
    </UserStateContext.Provider>
  )
}

export const useUser = () => useContext(UserStateContext);